import "./styles/main.scss";
import { App } from "./app";
import { WatermarkOverlay } from "./components";

if (location.pathname === "/iframe") {
    const playerTime = new BroadcastChannel("web-player-time");
    playerTime.onmessage = (event) => {
        const time = event.data;
        if (time !== undefined) {
            window.parent.postMessage({ type: "timeUpdate", time }, "*");
        }
    };
    window.parent.postMessage({ type: "timeUpdate", time: 0 }, "*");
    const playerSeek = new BroadcastChannel("web-player-seek");

    window.addEventListener("message", (event) => {
        if (event.data.type === "seek") {
            const { time } = event.data;
            if (time !== undefined) {
                playerSeek.postMessage(time);
                console.log("Seeking to time:", time);
            }
        }
    });
} else {
    const app = new App();
    console.log("app:", app);
    document.addEventListener("DOMContentLoaded", () => {
        app.initiate();
        new WatermarkOverlay();
    });
}
